import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import LifeAtSecondaryButton from "@common/LifeAtButton/Variants/LifeAtSecondaryButton";
import TimerWidgetToolbarIcon from "@icons/WidgetToolbar/Timer-ToolbarWidget-Icon.svg";
import { RoomParams } from "../../../../features/room/RoomTypes";
import { useHeadlessPomodoroReadonly } from "../../../../features/widget-workspace/components/Widget/TimerWidget/hooks/useHeadlessPomodoroReadonly";

const StyledTimerIcon = styled(TimerWidgetToolbarIcon)`
    fill: ${({ theme }) => theme.textColorPrimary};
`;

const TimerButton = styled(LifeAtSecondaryButton)`
    .lifeat-button-text {
        min-width: 50px;
    }
`;

const TIMER_AIRTABLE_FEEDBACK_URL = "https://airtable.com/shrSSYspwuF0lxSui";

export default function GroupTimerButton() {
    const { roomId }: RoomParams = useParams();

    const {
        timerDisplayText,
        lastEvent: { isRunning: isGroupPomodoroTimerRunning },
    } = useHeadlessPomodoroReadonly(roomId);

    return isGroupPomodoroTimerRunning ? (
        <TimerButton
            isLink={true}
            icon={<StyledTimerIcon />}
            link={TIMER_AIRTABLE_FEEDBACK_URL}
            text={timerDisplayText}
        />
    ) : null;
}
